import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { LoadingApp } from '../Loading/Loading';

export function withAppReady(WrappedComponent) {
  class WithAppReady extends React.PureComponent {
    render() {
      const { app, ...rest } = this.props;
      const { isReady } = app;
      if (!isReady) {
        return <LoadingApp loading />;
      }
      return <WrappedComponent {...rest} />;
    }
  }

  function mapStateToProp(state) {
    return {
      app: state.app,
    };
  }

  return withRouter(connect(mapStateToProp)(WithAppReady));
}
